// @flow
import React, { type Element } from 'react';
import { urlCatalog, Track } from 'angieslist-app-platform';

export const DealsEmptyStateComponent = (): Element<"div"> => (
  <div>
    <p className="lead">
      <i
        className="icon icon-lg icon-outlined-offercard text-danger"
        style={{
          marginRight: 10,
        }}
      />
      You currently do not have any deals listed.
    </p>
    <p>
      When you participate in our Deals solution, you can create exclusive deals to
      highlight your business as consumers narrow their search for a service.
    </p>
    <p>
      To find out if you’re eligible to participate give us a call at:&nbsp;
      <Track>
        <a
          id="deals-empty-state--phone-button"
          href={urlCatalog.global.businessCenterPhone()}
          className="text-nowrap"
        >
          <strong>{urlCatalog.global.businessCenterPhoneText()}</strong>
        </a>
      </Track>
    </p>
  </div>
);

export default DealsEmptyStateComponent;



// WEBPACK FOOTER //
// ./src/modules/store/browser/components/DealsEmptyState.js